import {
  Job,
  StateMachineContext,
  JobHandler,
  JobOptions,
  JobQueueJobs,
  StateMachineState,
  StateActorActions,
} from './types'
import { JobQueueClient } from './JobQueueClient'

export class StateActor<
  Data,
  State extends StateMachineState,
  Context extends StateMachineContext,
  Result
> {
  constructor(
    readonly name: string,
    protected readonly handler: JobHandler<
      Data,
      State,
      Context,
      Result
    >
  ) {}

  enqueue<Q extends JobQueueClient<State, JobQueueJobs>>(
    queueClient: Q,
    data: Data,
    options?: JobOptions
  ) {
    return queueClient.enqueue<keyof JobQueueJobs, Data>(
      this.name as keyof JobQueueJobs,
      data,
      options
    )
  }

  waitForJob<Q extends JobQueueClient<State, JobQueueJobs>>(
    queueClient: Q,
    jobId: string
  ) {
    return queueClient.waitForJob<Result>(jobId)
  }

  process(
    data: Data,
    context: { state: State; job: Job; context: Context },
    _actions: StateActorActions<State>
  ) {
    return this.handler(data, context)
  }
}
